import React from 'react';
import { DossierContext } from './dossier.context';
import { useBailleursDossierReadLazyQuery } from 'common-app/api/query/dossier-read';
import { useParams } from 'react-router-dom';
import { useAuthContext } from '@isyc-react/auth/modules/context';
import { useUserSecurityTokensQuery } from '@isyc-react/oc-api';
import { useBailleursDossierIsAccessibleQuery } from 'common-app/api/query/dossier-accessible';
import { DossierStep } from './dossier.vm';
export const DossierProvider = props => {
    const { children } = props;
    const [dossier, setDossier] = React.useState(null);
    const { dossierId } = useParams();
    const { status, user, setUserSession } = useAuthContext();
    const { data: isAccessibleData, error: isAccessibleError, loading: isAccessibleLoading, refetch: isAccessibleRefetch } = useBailleursDossierIsAccessibleQuery({
        variables: { dossierId: dossierId ? parseInt(dossierId) : undefined },
    });
    const [dossierQuery, { data: dossierData, error: dossierError, loading: dossierLoading, refetch: dossierRefetch }] = useBailleursDossierReadLazyQuery({
        variables: { dossierId: dossierId ? parseInt(dossierId) : undefined },
    });
    const error = isAccessibleError || dossierError;
    const loading = isAccessibleLoading || dossierLoading;
    const { data: dataSecurity } = useUserSecurityTokensQuery({ variables: { securityTokenList: ['PORTAL_RESTRICTIONS'] } });
    React.useEffect(() => {
        var _a;
        if (isAccessibleData && isAccessibleData.bailleurs_dossier_is_accessible) {
            const accessibleData = isAccessibleData.bailleurs_dossier_is_accessible;
            if (accessibleData.accessible) {
                dossierQuery();
            }
            else {
                setDossier({
                    id: 0, step: DossierStep.ERROR, error: (_a = accessibleData.message) !== null && _a !== void 0 ? _a : ''
                });
            }
        }
    }, [isAccessibleData]);
    React.useEffect(() => {
        var _a;
        if (dossierData && dossierData.bailleurs_dossier_read) {
            setDossier(dossierData.bailleurs_dossier_read);
            user &&
                setUserSession({
                    status,
                    user: Object.assign(Object.assign({}, user), { businessUnit: Object.assign(Object.assign({}, user.businessUnit), { id: (_a = dossierData.bailleurs_dossier_read.businessUnitId) !== null && _a !== void 0 ? _a : 0 }) }),
                });
        }
    }, [dossierData]);
    const userHasSecurityToken = React.useMemo(() => {
        var _a;
        return (_a = dataSecurity === null || dataSecurity === void 0 ? void 0 : dataSecurity.user_hasTokens[0].hasSecurityToken) !== null && _a !== void 0 ? _a : false;
    }, [dataSecurity]);
    return (React.createElement(DossierContext.Provider, { value: {
            dossier,
            error: Boolean(error),
            loading,
            refresh: dossierRefetch,
            setDossier,
            userHasSecurityToken
        } }, children));
};
